import { Button, Typography } from '@pankod/refine-antd';
import { AppInstanceCreateModal } from 'components/modal';
import { useState } from 'react';

const { Text } = Typography;

export const AppNotFound: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <AppInstanceCreateModal isModalOpen={isModalOpen} closeModal={closeModal} />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <Text
            style={{
              textTransform: 'uppercase',
              fontSize: '1rem',
              display: 'block',
              letterSpacing: 2,
            }}
          >
            Welcome to Elobooks
          </Text>
          <Text
            style={{
              fontSize: '2.5rem',
              lineHeight: 1.2,
              fontWeight: 600,
              display: 'block',
            }}
          >
            There is no app setups available yet,
          </Text>
          <Text
            style={{
              fontSize: '2.5rem',
              lineHeight: 1.2,
              fontWeight: 600,
              display: 'block',
              marginBottom: '1.5rem',
            }}
          >
            create the first setup now.
          </Text>
          <Button
            type="primary"
            size="large"
            onClick={() => setIsModalOpen(true)}
            style={{ paddingLeft: '4rem', paddingRight: '4rem' }}
          >
            Create Now
          </Button>
        </div>
      </div>
    </>
  );
};
